const boundsFromRegion = region => [
  [region.longitude - region.longitudeDelta, region.latitude - region.latitudeDelta],
  [region.longitude + region.longitudeDelta, region.latitude + region.latitudeDelta],
]

export default boundsFromRegion
